import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentindaund() {



  const cardData =
  {
    keyword: 'Urbania On Rent in Daund',
    heading: 'Sanavi Travels: Urbania On Rent in Daund',
    headingDescription: 'Sanavi Travels offers reliable Urbania On Rent in Daund, providing safe, comfortable, and convenient transportation for families, small groups, corporate travelers, and pilgrims. Our fleet of well-maintained Urbania vehicles ensures smooth rides, air-conditioning, and ample luggage space for a hassle-free journey. With professional chauffeurs, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Daund and nearby areas, making it ideal for local travel, outstation trips, Shirdi visits, airport transfers, and family outings. Choose Sanavi Travels for trusted Urbania rental services in Daund, delivering comfort, safety, and a seamless travel experience.',

    top: 'Top Places to Visit in Daund with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Located near Daund, Bhigwan Bird Sanctuary is a paradise for bird lovers and nature enthusiasts. Often called the 'Bharatpur of Maharashtra,' it attracts migratory birds like flamingos, pelicans, and storks, especially during winter. Boat safaris and sunrise views make it a must-visit destination."
  },
  {
    "title": "Ujani Dam Backwaters",
    "description": "The backwaters of Ujani Dam near Daund offer a serene landscape of vast water spread and open skies. The area is ideal for peaceful outings, photography, and birdwatching, particularly during early mornings and evenings."
  },
  {
    "title": "Shri Siddheshwar Temple",
    "description": "Shri Siddheshwar Temple is an important local religious site in Daund, attracting devotees throughout the year. The temple is known for its calm spiritual atmosphere and traditional rituals performed during festivals."
  },
  {
    "title": "Daund Railway Junction",
    "description": "Daund Railway Junction is one of the major railway hubs in Maharashtra, connecting important routes toward Pune, Solapur, and southern India. The historic junction plays a vital role in trade, travel, and regional connectivity."
  },
  {
    "title": "Bhigwan Wetlands",
    "description": "The wetlands around Bhigwan near Daund support rich biodiversity and seasonal migratory birds. Nature walks and boat rides allow visitors to experience untouched natural beauty and rural landscapes."
  },
  {
    "title": "Local Sugar Factories Area",
    "description": "Daund is surrounded by sugarcane fields and sugar factories that represent the agricultural backbone of the region. These areas highlight rural life and Maharashtra’s cooperative farming culture."
  },
  {
    "title": "Village Temples and Wadas",
    "description": "Traditional village temples and old wadas around Daund reflect the cultural and architectural heritage of rural Maharashtra. These sites offer insight into local traditions, festivals, and community life."
  },
  {
    "title": "Indapur Road Countryside",
    "description": "The countryside along Indapur Road near Daund offers scenic drives with open fields, canals, and sunset views. It is ideal for short nature breaks and relaxed travel experiences."
  },
  {
    "title": "Local Weekly Markets",
    "description": "Weekly markets in Daund are vibrant centers of local trade, selling fresh produce, grains, livestock, and daily essentials. They provide an authentic experience of rural Maharashtra’s lifestyle."
  },
  {
    "title": "Pilgrimage Routes Nearby",
    "description": "Daund lies on important travel routes connecting Pune, Solapur, Pandharpur, and Bhigwan. Many pilgrims use Daund as a transit point while visiting major religious destinations."
  }
]
,



"services": [
  {
    "name": "Urbania On Rent in Daund",
    "description": "Urbania On Rent in Daund provides spacious and comfortable group travel options for families, friends, and corporate clients. Equipped with air-conditioning and modern interiors, it is perfect for city travel, outstation trips, and special events. Professional drivers ensure safe and timely journeys, making every trip stress-free and enjoyable."
  },
  {
    "name": "Force Urbania Hire Daund",
    "description": "Force Urbania Hire Daund offers flexible rental solutions for daily commutes, sightseeing, and long-distance travel. Well-maintained vehicles with experienced chauffeurs ensure a smooth and comfortable ride, catering to family outings, group trips, and corporate transportation."
  },
  {
    "name": "AC Urbania Daund",
    "description": "AC Urbania Daund ensures a cool and relaxing journey for all passengers. Ideal for hot summer days, long-distance travel, and corporate commutes, the fully air-conditioned interiors provide comfort, cleanliness, and a stress-free travel experience."
  },
  {
    "name": "Luxury Urbania Daund",
    "description": "Luxury Urbania Daund delivers a premium travel experience with elegant interiors, spacious seating, and modern amenities. Perfect for VIP clients, corporate travel, weddings, and group tours, this service emphasizes comfort, style, and punctuality with chauffeur-driven convenience."
  },
  {
    "name": "Outstation Urbania Daund",
    "description": "Outstation Urbania Daund offers reliable long-distance travel for groups heading to nearby cities and tourist destinations. Air-conditioned interiors, ample luggage space, and professional chauffeurs ensure a safe, comfortable, and timely journey, whether for leisure or corporate travel."
  },
  {
    "name": "Corporate Urbania Daund",
    "description": "Corporate Urbania Daund provides efficient group transportation for business meetings, corporate events, and employee travel. With trained drivers, punctual service, and air-conditioned comfort, it ensures a productive and stress-free travel experience for corporate clients."
  },
  {
    "name": "Family Urbania Daund",
    "description": "Family Urbania Daund is designed for safe, convenient, and comfortable family travel. With spacious seating, air-conditioning, and professional chauffeurs, it is ideal for vacations, family gatherings, and local or outstation trips, ensuring a smooth and enjoyable journey."
  },
  {
    "name": "Affordable Urbania Daund",
    "description": "Affordable Urbania Daund offers budget-friendly rental options without compromising on safety or comfort. Ideal for students, small families, and groups seeking reliable and economical travel solutions, this service provides a balance of affordability and quality."
  },
  {
    "name": "Chauffeur Driven Urbania",
    "description": "Chauffeur Driven Urbania offers a stress-free and safe travel experience with professional drivers managing navigation, traffic, and timing. Suitable for corporate clients, families, and tourist groups, this service ensures a smooth, comfortable, and reliable journey."
  },
  {
    "name": "Best Urbania Service Daund",
    "description": "Best Urbania Service Daund focuses on delivering high-quality rental services with well-maintained vehicles and professional chauffeurs. Perfect for weddings, corporate events, family trips, and outstation travel, it emphasizes comfort, reliability, and excellent customer satisfaction."
  },
  {
    "name": "Railway Pickup Urbania",
    "description": "Railway Pickup Urbania ensures convenient transfers for passengers arriving at Daund railway stations. Timely pickups, experienced drivers, and comfortable air-conditioned vehicles make train travel hassle-free and enjoyable."
  },
  {
    "name": "Group Travel Urbania Daund",
    "description": "Group Travel Urbania Daund provides organized and comfortable transportation for family gatherings, friend trips, corporate outings, and social events. Air-conditioned vehicles with professional chauffeurs make group travel convenient, safe, and enjoyable."
  },
  {
    "name": "Tourist Urbania Daund",
    "description": "Tourist Urbania Daund is ideal for sightseeing and leisure trips in and around Daund. Comfortable, air-conditioned vehicles with experienced drivers ensure organized and safe travel for families, friends, and tourist groups exploring local attractions."
  },
  {
    "name": "Online Booking Urbania",
    "description": "Online Booking Urbania allows users to reserve Urbania vehicles easily via an online platform. Customers can select vehicle type, pickup location, trip dates, and preferences with instant confirmation, ensuring hassle-free, safe, and reliable travel planning."
  },
  {
    "name": "Daund Travel Urbania",
    "description": "Daund Travel Urbania provides complete travel solutions for city tours, outstation trips, and group travel. Well-maintained vehicles with professional chauffeurs ensure safe, comfortable, and enjoyable journeys for families, corporate clients, and tourist travelers."
  }
],
"tableData": [
  ["Urbania On Rent in Daund", "Force Urbania Hire Daund"],
  ["AC Urbania Daund", "Luxury Urbania Daund"],
  ["Outstation Urbania Daund", "Family Urbania Daund"],
  ["Corporate Urbania Daund", "Affordable Urbania Daund"],
  ["Chauffeur Driven Urbania", "Best Urbania Service Daund"],
  ["Railway Pickup Urbania", "Group Travel Urbania Daund"],
  ["Tourist Urbania Daund", "Online Booking Urbania"],
  ["Daund Travel Urbania", "—"]
]
,

"whychoose": [
  {
    "WhyChooseheading": "Urbania On Rent in Daund with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and affordable Urbania rentals in Daund, perfect for daily travel, family outings, airport transfers, local trips, and outstation journeys."
  },
  {
    "WhyChooseheading": "Well‑Maintained and Comfortable Urbania",
    "WhyChoosedescription": "Travel in clean, air‑conditioned, and regularly serviced Urbania vehicles that ensure a smooth and enjoyable ride."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and familiar with local Daund and nearby routes, providing safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Urbania rentals in Daund, including fuel, tolls, and driver allowances without any hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your Urbania rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from local, one‑way, round‑trip, or customized rental packages based on your travel requirements in Daund."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Urbania vehicles are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Urbania rentals in Daund."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Urbania on rent in Daund?',
    answer: 'Yes, Sanavi Travels offers Urbania rentals in Daund for comfortable and affordable travel.'
  },
  {
    question: 'How can I book an Urbania in Daund?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Is the Urbania well‑maintained and air‑conditioned?',
    answer: 'Yes, all Urbania vehicles provided by Sanavi Travels are clean, air‑conditioned, and regularly serviced.'
  },
  {
    question: 'Are drivers experienced with Daund routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with local and nearby routes for safe travel.'
  },
  {
    question: 'Can I rent Urbania for local or outstation travel?',
    answer: 'Absolutely. You can choose local, one‑way, round‑trip, or customized travel packages based on your needs.'
  },
  {
    question: 'Is the Urbania rental service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round‑the‑clock support for Urbania rentals in Daund.'
  },
  {
    question: 'Are the vehicles sanitized before every trip?',
    answer: 'Yes, all Urbania vehicles are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'What payment options are available for Urbania bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Urbania rental journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Deshmukh',
    feedback: 'Rented an Urbania in Daund for a family trip. Comfortable ride and excellent service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Great experience with Urbania rental in Daund. Clean vehicle and professional driver.',
    rating: 5
  }
];

















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Daund - Sanavi Travels",
  "description": "Sanavi Travels offers Force Urbania rental in Daund for outstation trips, family travel, corporate transport, group tours, and tourist travel. AC, luxury, and chauffeur-driven options available along with railway pickup and online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "310"
  }
};



  return (
    <div>

<Helmet>
  <title>
    Urbania On Rent in Daund | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Force Urbania in Daund with Sanavi Travels for outstation, family, corporate, group, and tourist travel. AC, luxury, chauffeur-driven options available with railway pickup and online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/99.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaonrentindaund;